import { WorkoutMergeModal } from './WorkoutMergeModal';

export default WorkoutMergeModal;
